import { ReactElement } from 'react';
import { BlockProps } from './types';

export function Block(props: BlockProps): ReactElement | null {
  if (props.if) {
    return <>{props.children}</>;
  }

  return null;
}
